import React__default from 'react';

const StepsContext = /*#__PURE__*/React__default.createContext({
  activeStep: 0
});
const useStepsContext = () => React__default.useContext(StepsContext);
const StepsProvider = ({
  value,
  children
}) => {
  const [widths, setWidths] = React__default.useState([]);
  const [stepSizes, setStepSizes] = React__default.useState(['sm', 'md', 'lg']);
  const isError = value.state === 'error';
  const isLoading = value.state === 'loading';
  const isVertical = value.orientation === 'vertical';
  const isLabelVertical = value.orientation !== 'vertical' && value.labelOrientation === 'vertical';
  return /*#__PURE__*/React__default.createElement(StepsContext.Provider, {
    value: {
      ...value,
      widths,
      setWidths,
      stepSizes,
      setStepSizes,
      isError,
      isLoading,
      isVertical,
      isLabelVertical
    }
  }, children);
};
StepsProvider.displayName = "StepsProvider";

export { StepsProvider, useStepsContext };
